import styled from 'styled-components';
import { Colors } from '../../constants/Colors';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 20px;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  color: ${Colors?.commons.black || '#111'};
  margin: 0;
`;
